import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Card, Alert, Modal } from 'react-bootstrap'
import { formatCurrency, IsSpecialEmployer, IsVehicleElectric } from 'application/helpers'
import ContactConsultant from 'application/components/contactConsultant'
import { AccordionCard } from '../../accordion'
import Tooltip from '../../tooltip'
import ContactUsDialog from '../../dialog/contactUsDialog'
import ProceedWithEstimateButton from '../../actionEvents/proceedWithEstimateButton'
import { applicationRoles } from 'application/constants/actionTypes'
import { TermsAndConditions } from '../../termsAndConditions'
import { TermsAndConditionsRS } from '../../termsAndConditionsRS'
import { MdErrorOutline } from 'react-icons/md'
import { PrimaryButton } from '@mmsg/louie'
import { useHistory } from 'react-router-dom'
import * as E from './endOfLeaseSectionElements'
import * as S from './estimateDetailElements'
import EstimateSummarySection from './estimateSummarySection'
import { SummarySheet } from '../pdf/summarySheet'
import { SummarySheetMX } from '../pdf/summarySheetMX'
import RfbaSection from '../proposal/rfbaSection'
import { EstimateDetailStaticData } from './estimateDetailStaticData'
import { Icon as RemServIcon } from 'RemServ/icons'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'

const EndOfLeaseSection = ({
  data: {
    leaseResidualAmountIncGST,
    brand,
    userFirstName,
    consultantFirstName,
    year,
    make,
    family,
    vehicleId,
    vehicleDescription,
    payFrequency,
    residualPCT,
    opportunityId,
    showRecommendedRetailPrice,
    annualRate,
    fbtMethod,
    leaseTerm,
    kmPerAnnum,
    nlFeePerPay,
    financeAmount,
    carRepaymentPerPayExGST,
    totalLeaseRunningCostsPerPayExGST,
    compInsuranceCommissionPerAnnumIncGST,
    gapCoverCommissionPerAnnumIncGST,
    vehicleFBTValue,
    financierEstablishmentFeePerAnnum,
    rpcCommissionPerAnnumIncGST,
    brokeragePerAnnum,
    compInsuranceCommissionExGST,
    compInsuranceCommGST,
    gapCoverCommissionExGST,
    gapCoverCommGST,
    rpcCommissionExGST,
    rpcCommGST,
    financierEstablishmentFee,
    brokerage,
    isIndicativeProposal,
    nlFeePerAnnumIncGST,
    spFeePerAnnumIncGST,
    extendedWarrantyCommGST,
    extendedWarrantyCommExGST,
    extendenWarrantyCommissionPerAnnumIncGST,
    leaseProtectionCommissionPerAnnumIncGST,
    leaseProtectionCommExGST,
    leaseProtectionCommGST,
    procurementFee,
    vehicleLeaseValue,
    nlFeePerPayExGST,
    isGov,
    rpcProvider,
    extendedWarrantyProvider,
    financierFeePerPay,
    monthlyRepaymentAmountIncGST,
    vehicleAccessoriesNames,
    accesoriesByYou,
    thirdPartyOption,
    specm,
    preTaxPerPay
  },
  applicationRole,
  expandAccordion,
  proposalMadeEstimateInvalid,
  isValid,
  pdfViewClick,
  afterMarketAccessories,
  novatedLeaseData,
}) => {
  let [viewSummarySheet, setViewSummarySheet] = useState(false)

  const toggleViewSummarySheet = () => {
    setViewSummarySheet(!viewSummarySheet)
  }
  const isExGST = useSelector((state) => state.user.employer.employerGRS.gstExclusiveDeductionsCode.toLowerCase() === 'yes')
  let isConsultant = applicationRole === applicationRoles.CONSULTANT

  let estimateID = useSelector(
    (state) => state.individualEstimate.selectedEstimateId
  )
  let hasSubmissionFailed = useSelector(
    (state) =>
      state.proceedEstimate && state.proceedEstimate.hasSubmissionFailed
  )
  let submissionErrorMsg = useSelector(
    (state) =>
      state.proceedEstimate && state.proceedEstimate.errorMsgOnProceedEstimate
  )
  let showInterestRate = useSelector(
    (state) =>
      state.user.employer.employerGRS.displayInterestRateOnDigitalEstimate
  )
  let isPAC =
    (rpcProvider && rpcProvider.toLowerCase() === 'pac') ||
    (extendedWarrantyProvider &&
      extendedWarrantyProvider.toLowerCase() === 'pac')

  let isSAGov = IsSpecialEmployer('SAG', false)
  let isNSWHN = IsSpecialEmployer('NSWHN')
  let isSAGBYO = IsSpecialEmployer('SAGBYO') 
  let isREMEQ = IsSpecialEmployer('REMEQ')
  let isACTGO = IsSpecialEmployer('ACTGO')

  let showRFBA =  useSelector((state) =>
        IsVehicleElectric(state.individualEstimate.estimate, true)
      ) && fbtMethod && fbtMethod.toLowerCase() == 'exempt' && 
    vehicleFBTValue && vehicleFBTValue < 84916

  let history = useHistory()
  const employeeName = useSelector((state) => state.user.firstName + ' ' + state.user.lastName)
  
    const bpFC = useSelector((state) => state.opportunity.bpFuelProvider)
    const caltexFC = useSelector((state) => state.opportunity.caltexFuelProvider)
    const shellFC = useSelector((state) => state.opportunity.shellFuelProvider)
  
    let fuelCards = []
    if (bpFC)
       fuelCards.push('BP')
    if (caltexFC)
       fuelCards.push('Ampol')
    if (shellFC)
       fuelCards.push('Shell')
      
    const employeeNumber = useSelector((state) => state.user.employer.payrollId)
    const aftermarketOrderLines =
      afterMarketAccessories && afterMarketAccessories.aftermarketOrderLines
  
    const accessoriesByYou =
      thirdPartyOption && thirdPartyOption.thirdPartyOptionLines
  
    let accessories = []
    if(accessoriesByYou) {accessories.push(accessoriesByYou.map((x) => x.description))}
    const vehicleAccessory = useSelector((state) => state.individualEstimate.estimate && 
        state.individualEstimate.estimate.vehicle && 
        state.individualEstimate.estimate.vehicle.vehicleAccessories)
    if(vehicleAccessory) {accessories.push(vehicleAccessory.map((x) => x.name))}  
    aftermarketOrderLines && aftermarketOrderLines.forEach((item) => (accessories.push( item.description)))
      
  const GoBackToEstimatesPage = () => {
    if (isConsultant) {
      history.push('/consultant/estimates')
    } else {
      history.push('/estimates')
    }
  }

  let summarySheetData = {
    ...novatedLeaseData.proposalEstimate,
    employeeName,
    employeeNumber,
    fuelCards,
    isExGST,
    payFrequency,
    accessories
  }

  let estimateSummaryProps = {
    title: 'Estimate Summary',
    employerCode: isNSWHN ? 'NSWHN' : isGov ? 'QG' : isSAGBYO ? 'SAGBYO' : isACTGO ? 'ACTGO' : '' ,
    financeAmount: financeAmount,
    carRepaymentPerPayExGST: carRepaymentPerPayExGST,
    leaseResidualAmountIncGST: leaseResidualAmountIncGST,
    residualPCT: residualPCT,
    totalLeaseRunningCostsPerPayExGST: totalLeaseRunningCostsPerPayExGST,
    employerDisplayInterestRateOnDigitalEstimate: showInterestRate,
    annualRate: annualRate,
    nlFeePerPayExGST: nlFeePerPayExGST,
    vehicleFBTValue: vehicleFBTValue,
    vehicleProcurementFee: procurementFee,
    leaseTerm: leaseTerm,
    isPAC: isPAC,
    compInsuranceCommissionPerAnnumIncGST:
      compInsuranceCommissionPerAnnumIncGST,
    compInsuranceCommissionExGST: compInsuranceCommissionExGST,
    compInsuranceCommGST: compInsuranceCommGST,
    gapCoverCommissionPerAnnumIncGST: gapCoverCommissionPerAnnumIncGST,
    gapCoverCommissionExGST: gapCoverCommissionExGST,
    gapCoverCommGST: gapCoverCommGST,
    rpcCommissionPerAnnumIncGST: rpcCommissionPerAnnumIncGST,
    rpcCommissionExGST: rpcCommissionExGST,
    rpcCommGST: rpcCommGST,
    extendenWarrantyCommissionPerAnnumIncGST:
      extendenWarrantyCommissionPerAnnumIncGST,
    extendedWarrantyCommExGST: extendedWarrantyCommExGST,
    extendedWarrantyCommGST: extendedWarrantyCommGST,
    leaseProtectionCommissionPerAnnumIncGST:
      leaseProtectionCommissionPerAnnumIncGST,
    leaseProtectionCommExGST: leaseProtectionCommExGST,
    leaseProtectionCommGST: leaseProtectionCommGST,
    financierEstablishmentFeePerAnnum: financierEstablishmentFeePerAnnum,
    financierEstablishmentFee: financierEstablishmentFee,
    brokeragePerAnnum: brokeragePerAnnum,
    brokerage: brokerage,
    nlFeePerPay: nlFeePerPay,
    kmPerAnnum: kmPerAnnum,
    monthlyRepaymentAmountIncGST: monthlyRepaymentAmountIncGST,
    specm: specm,
    payFrequency: payFrequency,
    fbtMethod: fbtMethod,
    preTaxPerPay: preTaxPerPay
  }

  let SummarySheetButton = () => {
    return (
      <div className="w-100 mt-3 ml-3 mr-3">
        <PrimaryButton invertColor extendInMob onClick={toggleViewSummarySheet}>
          <RemServIcon iconType="Sheet" size={1} />
          View summary sheet
        </PrimaryButton>
      </div>
    )
  }

  let ProceedButton = () => {
    if (
      !proposalMadeEstimateInvalid &&
      !isIndicativeProposal &&
      !isConsultant &&
      isValid
    )
      return (
        <ProceedWithEstimateButton
          opportunityId={opportunityId}
          estimateId={estimateID}
          variant="primary"
          launchText="Proceed with this estimate"
          id="endoflease.proceedbutton"
          extendInMob
          className="mt-3"
        />
      )
    else
      return (
        <div className="mt-3 w-100">
          <PrimaryButton
            disabled
            extendInMob
            id="endoflease.readonlyproceedbutton"
          >
            Proceed with this estimate
          </PrimaryButton>
        </div>
      )
  }

  let ContactUsButton = () => {
    if (!isConsultant)
      return (
        <ContactUsDialog
          variant="invertColor"
          invertColor
          theme="button"
          extendInMob
          launchText="Contact my consultant"
          id="endoflease.contact"
          className="mt-3"
        />
      )
    else
      return (
        <PrimaryButton
          disabled
          id="endoflease.contactreadonly"
          size="sm"
          extendInMob
          className="mt-3 ml-3"
        >
          Contact my consultant
        </PrimaryButton>
      )
  }

  return (
    <>
      <Modal show={viewSummarySheet} onHide={toggleViewSummarySheet} size="lg">
        <Modal.Header
          closeButton
          style={{
            background: 'transparent',
            borderBottom: 'none',
            paddingBottom: 0,
          }}
        ></Modal.Header>
        <Modal.Body>
          <div>
            {global.config.isBrandMX && <SummarySheetMX summarySheetData={summarySheetData}/>}
            {global.config.isBrandRS && <SummarySheet novatedLeaseData={novatedLeaseData} exGst={true} />}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'start' }}>
          <PrimaryButton extendInMob onClick={pdfViewClick}>
            View PDF
          </PrimaryButton>
          <PrimaryButton
            extendInMob
            invertColor
            onClick={toggleViewSummarySheet}
          >
            Close
          </PrimaryButton>
        </Modal.Footer>
      </Modal>

      <Container
        className="section mt-3 mb-5 print-page-break-before"
        id="endOfLeaseSection"
      >
        <S.StyledH3 className="mb-4">
          And here’s what happens when your lease is up
        </S.StyledH3>
        <Card className="mb-13rem mt-3 card-shadow">
          <Card.Header className="border-bottom-0">
            <S.CardHeader xs md={9} className="px-0">
              Understanding your end of lease options
            </S.CardHeader>
          </Card.Header>
          <Card.Body>
            <Row className="mb-24">
              <Col md={8} xs={12}>
                <div className="font-weight-bold">
                  <div className="d-flex mb-3">
                    <S.SubHeadingDiv className="mr-1">
                      How it works: Residual value
                    </S.SubHeadingDiv>
                    <Tooltip
                      header="Residual value"
                      text="The anticipated amount owing on the car at the end of the lease, as set and required by the ATO."
                      id="endoflease.residualvaluetooptip"
                    />
                  </div>
                </div>
                <Row className="mb-24">
                  <Col>
                    <S.GreyTextDiv className="ml-0">
                      {EstimateDetailStaticData('ResidualValue')}
                    </S.GreyTextDiv>
                  </Col>
                </Row>
              </Col>
              <Col md={4} xs={12} className="sub-section-residual-amount">
                <E.ResidualBox>
                  <Card.Text>
                    <Row>
                      <S.BrandDefaultText className="ml-3 text-small">
                        Total residual value after lease term (inc GST)
                      </S.BrandDefaultText>
                    </Row>
                    <Row>
                      <S.BrandDefaultText
                        bold
                        className="text-larger ml-3 font-weight-bold"
                        id="endoflease.totalresidualvalue"
                      >
                        {formatCurrency(leaseResidualAmountIncGST)}
                      </S.BrandDefaultText>
                    </Row>
                    <Row className="mt-2">
                      <S.BrandDefaultText
                        className="ml-3 text-small"
                        id="endoflease.residualpercentage"
                      >
                        (Calculated at {residualPCT}%)
                      </S.BrandDefaultText>
                    </Row>
                  </Card.Text>
                </E.ResidualBox>
              </Col>
            </Row>
            <Row className="mb-24">
              <Col>
                <S.SubHeadingDiv>What are your options?</S.SubHeadingDiv>
                <S.GreyTextDiv className="ml-0">
                  It's always nice to get a feel for your options from the get
                  go. But don't worry, we'll be in touch well before your lease
                  ends to help you figure out which direction you'd like to take
                  next.
                </S.GreyTextDiv>
              </Col>
            </Row>
            <Row className="text-center sub-section-lease-options">
              <Col sm>
                <div className="mb-2">
                  {global.config.isBrandRS && (
                    <RemServIcon iconType="LeaseUpgrade" />
                  )}
                  {global.config.isBrandMX && (
                    <MaxxiaIcon iconType="LeaseUpgrade" />
                  )}
                </div>
                <E.EOLOptionTitles>Upgrade</E.EOLOptionTitles>
                <S.BrandDefaultText className="text-small mb-24 mt-3">
                  Relive that new car feeling and cash in on the convenience of
                  upgrading with {brand}.
                </S.BrandDefaultText>
              </Col>
              <Col sm>
                <div className="mb-2">
                  {global.config.isBrandRS && (
                    <RemServIcon iconType="LeaseRelease" />
                  )}
                  {global.config.isBrandMX && (
                    <MaxxiaIcon iconType="LeaseRelease" />
                  )}
                </div>
                <E.EOLOptionTitles>Re-lease</E.EOLOptionTitles>
                <S.BrandDefaultText className="text-small mb-24 mt-3">
                  Keep enjoying the car (and estimated tax savings) by extending
                  your {brand} lease.
                </S.BrandDefaultText>
              </Col>
              <Col sm>
                <div className="mb-2">
                  {global.config.isBrandRS && (
                    <RemServIcon iconType="LeasePayout" />
                  )}
                  {global.config.isBrandMX && (
                    <MaxxiaIcon iconType="LeasePayout" />
                  )}
                </div>
                <E.EOLOptionTitles>Pay it out</E.EOLOptionTitles>
                <S.BrandDefaultText className="text-small mb-24 mt-3">
                  Whether you sell the car or buy it, you'll need to pay out
                  your residual.
                </S.BrandDefaultText>
              </Col>
            </Row>

            <AccordionCard
              expandAccordion={expandAccordion}
              className="mb-3"
              title="Can someone help me sell my other car if I upgrade?"
              id="endoflease.sellexistingaccordion"
              smallerTitleText={global.config.isBrandRS}
            >
              <S.BrandDefaultText>
                {EstimateDetailStaticData('SellOtherCarUpgrade')}
              </S.BrandDefaultText>
            </AccordionCard>
            <AccordionCard
              expandAccordion={expandAccordion}
              title="Do I have to pay the residual?"
              id="endoflease.residualaccordion"
              smallerTitleText={global.config.isBrandRS}
            >
              <S.BrandDefaultText>
                Yep, the residual is an ATO-legislated amount calculated as a
                percentage of the car's original value. We calculate it for you
                upfront so you know what you’re up for. Be sure to chat with a{' '}
                {global.config.brand} consultant near the end of your lease
                about your options for paying out the amount.
              </S.BrandDefaultText>
            </AccordionCard>
          </Card.Body>
        </Card>

        {(isSAGov || isNSWHN || isGov || isSAGBYO || isREMEQ || isACTGO) && (
          <EstimateSummarySection {...estimateSummaryProps} />
        )}

        {showRFBA && (
          <RfbaSection
            pdf={false}
            title="Electric Vehicle FBT Exemption - What you need to know"
            className="mt-6"
          />
        )}

        <Card body className="mt-3 card-shadow">
          <E.CongratulationsDiv id="endoflease.congratulations">
            Congratulations {userFirstName}! You’re ready to drive your salary
            further with {global.config.brand}.
          </E.CongratulationsDiv>
          <S.BrandDefaultText className="mb-3" id="endoflease.timetolockin">
            Like what you see? Time to lock in that
            {vehicleId && (
              <>
                {' '}
                {year} {make} {family}{' '}
              </>
            )}
            {!vehicleId && <> {vehicleDescription} </>}
            and proceed with this estimate. If you want to make changes, simply
            contact your consultant.
          </S.BrandDefaultText>
          <div className="print hide-to-print">
            <div>
              <E.EOLButtonContainer>
                {(isGov || IsSpecialEmployer('REMEQ') || IsSpecialEmployer('VICPO')) && <SummarySheetButton />}
                <ProceedButton />
                {(!isGov && !IsSpecialEmployer('REMEQ') && !IsSpecialEmployer('VICPO')) && <ContactUsButton />}
              </E.EOLButtonContainer>

              {isGov && (
                <div className="text-center">
                  <ContactUsDialog
                    className="link font-weight-bold text-underline mb-3 text-dark"
                    theme="link"
                    launchText="Contact my consultant"
                    inlineText
                  />
                </div>
              )}
            </div>
            {hasSubmissionFailed &&
              submissionErrorMsg !== '' &&
              submissionErrorMsg !== 'Sparta vehicle no longer available.' && (
                <div>
                  <Alert variant="danger" className="text-left mt-3 w-100">
                    <MdErrorOutline
                      color="#AD240A"
                      size={`1.6em`}
                      style={{
                        minWidth: '20px',
                        position: 'absolute',
                        left: '3px',
                      }}
                    />
                    <div className="text-small ml-3">
                      <div className="mb-1">
                        {submissionErrorMsg.replace(
                          /(500)|(405)|(401)|(400)/g,
                          ''
                        )}{' '}
                        <ContactConsultant
                          textPrefix="Please"
                          textUnderline="contact your consultant"
                          textPostfix="to discuss."
                        />
                      </div>
                    </div>
                  </Alert>
                </div>
              )}
          </div>
        </Card>
        {hasSubmissionFailed &&
          submissionErrorMsg === 'Sparta vehicle no longer available.' && (
            <Alert variant="danger" className="text-left mt-3 w-100">
              <E.styledAlertIcon />
              <div className="text-small ml-3 mb-1">
                <b>
                  Unfortunately this car is no longer available, as it was part
                  of a limited stock order.
                </b>
                <p>
                  You can view your other{' '}
                  <E.styledLink onClick={GoBackToEstimatesPage}>
                    estimates
                  </E.styledLink>{' '}
                  or{' '}
                  {isConsultant ? (
                    'chat to your consultant'
                  ) : (
                    <>
                      <ContactUsDialog
                        className="link"
                        theme="link"
                        launchText="chat to your consultant"
                      />
                    </>
                  )}{' '}
                  about other cars.
                </p>
              </div>
            </Alert>
          )}
      </Container>
      {global.config.isBrandMX && (
        <TermsAndConditions
          payFrequency={payFrequency}
          showRecommendedRetailPrice={showRecommendedRetailPrice}
          nlFeePerAnnumIncGST={nlFeePerAnnumIncGST}
          financierEstablishmentFee={financierEstablishmentFee}
          fbtMethod={fbtMethod}
          spFeePerAnnumIncGST={spFeePerAnnumIncGST}
          financierFeePerPay={financierFeePerPay}
        />
      )}
      {global.config.isBrandRS && (
        <TermsAndConditionsRS
          fbtMethod={fbtMethod}
          displayRetailPrice={showRecommendedRetailPrice}
          isGov={isGov}
          payFrequency={payFrequency}
          financierFeePerPay={financierFeePerPay}
        />
      )}
    </>
  )
}

export default EndOfLeaseSection
